import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import LoadingIndicator from './component/loading-indicator'
// import reportWebVitals from './reportWebVitals'

import './index.css'

ReactDOM.render(
    <BrowserRouter>
        <App />
        <LoadingIndicator />
    </BrowserRouter>,
    document.getElementById('root')
)

// reportWebVitals(console.log)
